import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import FieldWrapper from '../../../components/formInputs/FieldWrapper';
import SectionHeader from '../../../components/SectionHeader';
import Button from '../../../components/buttons/Button';
import { useRef } from 'react';
import { scrollToError } from '../../../utils/HelperFunctions';

import { useParams } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { ISpecGroup } from '../types/interfaces';
import FormDynamicSkeleton from '../../../components/loaders/FormDynamicSkeleton';
import useFormsIntegrationHelpers from '../../../hooks/useFormsIntegrationHelpers';

const CreateSpecificationGroupForm = () => {
  const { id } = useParams();
  const formRef = useRef(null);
  const { t } = useTranslation();

  const { apiData, getDataLoading, handleSubmit, submitLoading } = useFormsIntegrationHelpers({
    queryKey: ['specs-groups', id],
    invalidateQueryKey: ["specs-groups"],
    id,
    singleGetApi: `/admin/specs-groups/${id}`,
    addApi: '/admin/specs-groups',
    editApi: `/admin/specs-groups/${id}`,
    listRoute: '/specification-groups',
    itemName: t('specification_groups'),
  });

  const validationSchema = Yup.object({
    // icon: Yup.mixed().required(t('required')),
    name: Yup.object().shape({
      ar: Yup.string()
        .required(t('required'))
        // .matches(/^[\u0600-\u06FF\s]+$/, t('must_ar'))
        .min(3, t('name_short')),
      en: Yup.string()
        .required(t('required'))
        // .matches(/^[A-Za-z\s]+$/, t('must_en'))
        .min(3, t('name_short'))
    })
  });


  const initialValues: ISpecGroup = {
    ...apiData,
    
    name: {
      en: apiData?.name?.en || '',
      ar: apiData?.name?.ar || ''
    }
  };

  if (getDataLoading)
    return (
      <FormDynamicSkeleton
        sections={[
          [
            { columns: 2, items: 2 },
          ]
        ]}
        buttons={1}
      />
    );

  return (
    <div className={'form_section'} ref={formRef}>
      <Formik
        validateOnMount
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { setErrors }) => {
          let value = { ...values, _method: 'POST' };
          if (id) {
            value = { ...value, _method: 'PUT' };
          }
          handleSubmit({ ...value }, setErrors);
        }}
      >
        {(formik) => (
          <>
            <Form>
              <SectionHeader title={t('specification_group_details')} customStyle='last'>
                {/* <div className="inputs_group">
                  <FieldWrapper>
                    <FormUpload errors={formik?.errors.icon as string} touched={formik?.touched?.icon as boolean} formik={formik} name={`icon`} label={t('icon')} />
                  </FieldWrapper>
                  <FieldWrapper noPadding />
                </div> */}
                <div className="inputs_group">
                  <FieldWrapper
                    title={t('name_en')}
                    inputName={`name[en]`}
                    inputPlaceholder={t('name_en')}
                    inputError={formik.errors.name?.en as string}
                    inputTouched={formik.touched.name?.en as boolean}
                    input
                    customPadding
                  />
                  <FieldWrapper
                    title={t('name_ar')}
                    inputName={`name[ar]`}
                    inputPlaceholder={t('name_ar')}
                    inputError={formik.errors.name?.ar as string}
                    inputTouched={formik.touched.name?.ar as boolean}
                    input
                    customPadding
                  />
                </div>
              </SectionHeader>
              <div className="form_button reverse">
                <Button
                  loading={submitLoading}
                  onClick={() => {
                    scrollToError(!formik.isValid, formRef);
                  }}
                >
                  <span className="bold">{t('save')}</span>
                </Button>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
};

export default CreateSpecificationGroupForm;
